import { Flex, Switch } from "antd";

const ShowDeletedTasksSwitch = ({
  checked,
  onChange,
  disabled = false,
  size = "default",
  className,
  style,
}) => (
  <Flex
    align="center"
    gap={size === "small" ? 6 : 8}
    className={className}
    style={style}
  >
    <Switch
      size={size}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
    />
    <span>Отображать удаленные задачи</span>
  </Flex>
);

export default ShowDeletedTasksSwitch;
